import {
    Col,
    Row,
    Card,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    CardText,
} from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Config from "config";
const ImpressionCard = ({ title, details, pme_id }) => {
    const navigate = useNavigate();
    const api = Config.backOffice.apiName;
    const backUrl = Config.backOffice.url;
    const token = localStorage.getItem("auth_token");
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [printDone, SetPrintDone] = useState(false);
    const [documentFusionData, setDocumentFusionData] = useState([]);
    const getDocumentFusionHm = async () => {
        try {
            await fetch(
                `https://www.fluxod.com/${api}/investissements/${id}/hm_documents_fusion`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    setDocumentFusionData(data);
                });
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        getDocumentFusionHm();
    }, [printDone]);
    const handleTemplateChange = (e) => {
        setSelectedTemplate(e);
    };
    let { id } = useParams();
    const renderTemplateOptions = (data) => {
        return [
            {
                options: data.map((dataItem) => ({
                    label: dataItem.label,
                    value: dataItem.id,
                })),
            },
        ];
    };
    const handleTemplateActionsClick = async (action) => {
        //print_one
        //edit
        var template_id = selectedTemplate?.value;
        if (template_id == null || "")
        {
            toast.error("Veuillez sélectionner un modèle");
        } 
        else if  ("print_one" == action.action) {
            toast.success("Impression en cours ...", { autoClose: 20000 });

                try {
                    const response = await fetch(
                        `https://www.fluxod.com/${api}/${action.controller}/${action.action}?investissement_id=${id}&publipostage_id=${selectedTemplate.value}&new_impression=1&pme_id=${pme_id}`,
                        {
                            method: "POST",
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    const donnee = await response.json();
                    if (response.status == 200) {
                        toast.success(donnee.message);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    } else {
                        throw new Error(
                            "La requête a échoué avec le statut " + response.status
                        );
                    }
                } catch (error) {
                    toast.error(error.message);
                }
            }     
           else {
                toast.error("Aucune action configurée");
            }
    };
    return (
        <Card className="mb-4">
            <CardTitle tag="h5" style={{ paddingLeft: 10 }}>
                {title}
            </CardTitle>
            <CardBody>
                {details ? (
                    Object.entries(details).map(([key, value], index) => (
                        <Row key={index} className="mb-3">
                            <Col className="col-2" style={{ whiteSpace: "nowrap" }}>
                                <i style={{ color: "#9d9c9c" }}>
                                    <span
                                        style={{
                                            display: "inline-block",
                                            width: "8em",
                                            whiteSpace: "nowrap",
                                            paddingTop: "0.5em"
                                        }}
                                    >
                                        {key} :
                                    </span>
                                </i>
                            </Col>
                            <Col className="col-6" style={{ whiteSpace: "nowrap" }}>
                                    <Select
                                        onChange={handleTemplateChange}
                                        options={renderTemplateOptions(value.select)}
                                        isClearable={true}
                                        className="select2"
                                    />
                            </Col>
                            {Object.entries(value.actions).map(([key_a,value_a],index_a) => (
                                <>
                                
                                    <Col className="col-2">
                                        {value_a?.action == "edit" && !(selectedTemplate?.value == null || "")  ? (
                                            <Link style={{ marginTop: "0.5em" }} className="btn btn-sm btn-info"  to={`https://www.fluxod.com/${api}/publipostages/${selectedTemplate.value}/redirect_to_real_controller?action=edit`} target="_blank" >
                                                {value_a.label}
                                            </Link>
                                        ) : (
                                            <Link to="#" style={{ marginTop: "0.5em" }} className="btn btn-sm btn-info" onClick={() =>
                                                handleTemplateActionsClick(value_a)
                                            }>
                                                {value_a.label}   
                                            </Link>
                                        )}
                                    </Col>
                                </>
                            )) }
                        </Row>
                    ))
                ) : (
                    <></>
                )}
                <ToastContainer />
            </CardBody>
        </Card>
    );
};
export default ImpressionCard;
